import { Input } from "antd";
import React, { useRef } from "react";
import { MenuOutlined } from "@ant-design/icons";
import WarningIcon from "../../../../assets/warning.svg";
import "../css/inputField.css";

export default function InputField({
  controlId,
  controlName,
  placeholder,
  inputType,
  value,
  handleInputChange,
  errorMessage,
  isReadOnly,
  minDate,
  isRequired,
  maxLength,
  pattern,
  customClassName,
  max,
  style,
  handleBlur,
  suffixIcon,
}) {
  const hasError = Boolean(errorMessage);

  const isTypingRef = useRef(false);

  const handleChange = (e) => {
    isTypingRef.current = true;
    handleInputChange(e);
  };

  const handleFieldBlur = (e) => {
    isTypingRef.current = false;
    handleBlur?.(e);
  };

  const displayValue = hasError && !isTypingRef.current ? "" : value || "";

  return (
    <Input
      id={controlId}
      name={controlName}
      type={inputType || "text"}
      value={displayValue}
      onChange={handleChange}
      onBlur={handleFieldBlur}
      readOnly={isReadOnly}
      min={minDate}
      required={isRequired}
      maxLength={maxLength}
      pattern={pattern}
      style={style}
      max={max}
      placeholder={hasError ? errorMessage : placeholder}
      suffix={
        hasError ? (
          <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            {suffixIcon || null}
            <img src={WarningIcon} alt="error" className="input-error-icon" />
          </span>
        ) : (
          suffixIcon || null
        )
      }
       className={`
       custom-input
       ${customClassName || ""}
       ${hasError ? "input-error" : ""}
       ${isReadOnly ? "read-only" : ""}
     `.trim()}
    />
  );
}
